"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Menu2 = _interopRequireDefault(require("@material-ui/core/Menu"));

var _Button2 = _interopRequireDefault(require("@material-ui/core/Button"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Add2 = _interopRequireDefault(require("@material-ui/icons/Add"));

var _CircularProgress2 = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _InputBase2 = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _InputAdornment2 = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Search2 = _interopRequireDefault(require("@material-ui/icons/Search"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _RecordItem = _interopRequireDefault(require("./RecordItem"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuLinkToRecord = function MenuLinkToRecord(_ref) {
  var anchorEl = _ref.anchorEl,
      onClose = _ref.onClose,
      onClickAdd = _ref.onClickAdd,
      onClickDelete = _ref.onClickDelete,
      onClickItem = _ref.onClickItem,
      onClickLink = _ref.onClickLink,
      isLoading = _ref.isLoading,
      fields = _ref.fields,
      _onSubmit = _ref.onSubmit,
      primaryField = _ref.primaryField,
      find = _ref.find,
      records = _ref.records;
  var data = records || [];
  return /*#__PURE__*/React.createElement(_Menu2["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: onClose,
    variant: "menu"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      _onSubmit();
    },
    style: {
      width: 600,
      paddingLeft: "1rem",
      paddingRight: "1rem"
    }
  }, find && /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: "0.5rem",
      borderBottom: "2px solid rgba(209, 213, 219,1)"
    }
  }, /*#__PURE__*/React.createElement(_InputBase2["default"], {
    value: find === null || find === void 0 ? void 0 : find.value,
    onChange: function onChange(e) {
      return find === null || find === void 0 ? void 0 : find.onChange(e.target.value);
    },
    autoFocus: true,
    fullWidth: true,
    placeholder: "Find an existing record",
    startAdornment: /*#__PURE__*/React.createElement(_InputAdornment2["default"], {
      position: "start"
    }, /*#__PURE__*/React.createElement(_Search2["default"], {
      fontSize: "small",
      style: {
        color: "rgba(156, 163, 175, 1)"
      }
    }))
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: 416,
      minHeight: 100,
      overflowY: "auto",
      paddingBottom: "0.75rem"
    }
  }, data && data.length ? data.map(function (item, i) {
    return /*#__PURE__*/React.createElement(_RecordItem["default"], {
      key: i,
      item: item,
      fields: fields || [],
      primaryField: primaryField || "name",
      onClickDelete: onClickDelete,
      onClick: function onClick() {
        onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(item);
      }
    });
  }) : /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      marginTop: "2rem"
    }
  }, isLoading ? /*#__PURE__*/React.createElement(_CircularProgress2["default"], null) : "No matching records")), onClickAdd && /*#__PURE__*/React.createElement(_Box2["default"], {
    style: {
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
      display: "flex",
      justifyContent: "center",
      cursor: "pointer",
      borderTop: "2px solid rgba(209, 213, 219,1)"
    },
    onClick: function onClick() {
      onClickAdd();
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Add2["default"], {
    fontSize: "small",
    style: {
      color: !(data !== null && data !== void 0 && data.length) && find !== null && find !== void 0 && find.value ? "#2D7FF9" : "unset"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500,
      marginLeft: "0.25rem",
      color: !(data !== null && data !== void 0 && data.length) && find !== null && find !== void 0 && find.value ? "#2D7FF9" : "rgba(75, 85, 99, 1)"
    }
  }, "Add new record ", find !== null && find !== void 0 && find.value ? "named \"".concat(find.value, "\"") : null)), onClickLink && /*#__PURE__*/React.createElement(_Box2["default"], null, /*#__PURE__*/React.createElement(_Button2["default"], {
    variant: "text",
    size: "small",
    startIcon: /*#__PURE__*/React.createElement(_Add2["default"], null),
    onClick: onClickLink,
    color: "primary"
  }, "Link to a record"))));
};

MenuLinkToRecord.propTypes = {
  anchorEl: _propTypes["default"].object,
  onClose: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  onClickItem: _propTypes["default"].func,
  onClickDelete: _propTypes["default"].func,
  onClickAdd: _propTypes["default"].func,
  onClickLink: _propTypes["default"].func,
  primaryField: _propTypes["default"].string,
  records: _propTypes["default"].array,
  find: _propTypes["default"].objectOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    onChange: _propTypes["default"].func
  })),
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    id: _propTypes["default"].string,
    type: _propTypes["default"].string
  })),
  isLoading: _propTypes["default"].bool
};
var _default = MenuLinkToRecord;
exports["default"] = _default;